export const COMISSOES_TITLE = 'Comissões';
export const TIPO_CALCULO_LABEL = 'Tipo de cálculo para as Comissões em uso na ABE';
export const ADD_RANGE_HINT = 'Adicionar Faixa';
export const RANGE_LABEL = 'Adicionar Faixa de Comissões por ';
export const RANGE_QUERY_LABEL = 'Faixa de Comissões por ';
